import styled from 'styled-components';

import theme from '@theme';
export const BannerLabel = styled.h6`
  color: white;
  margin-bottom: 0px;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  margin-right: 10px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 25px;
  }
`;

export const IconWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    width: 85px;
    height: 85px;
  }
`;

export const CampainBannerContainer = styled.div`
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 80px;
  background: ${theme.palette.bannerBgColor} url('/static/icons/starts-ico.svg')
    no-repeat right center;
  background-position: right;
  background-repeat: no-repeat;
  padding: 0 20px;
`;
